/*
 * File: ui-label.ts
 * File Created: 2023-12-18 11:45:26
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-27 10:50:49
 * Modified By: Val Liu
 * -----
 */

import { ObjectHelper } from "../../utilities";
import { IQuickUnit, QuickHelper } from "../../utilities/quick-helper";
import {
    BaseUITag,
    EUITagRuleType,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    IUITagMoreTagsUnit,
    UITag,
    IUIRelationPair,
    EUITagRuleUnion,
} from "../core";

interface IUISearchParents {
    quick: IQuickUnit;
    /// the field name. default to "name".
    name?: string;
    /// the field type. default to "string".
    type?: string;
}
const defaultData: Partial<IUISearchParents> = {
    name: "name",
    type: "string",
};

// @uiSearchParents - search on all quick's parent field, with "name" and "type".

@UITag.set()
export class uiSearchParents extends BaseUITag {
    appliedTo: EUITagTarget[] = [EUITagTarget.TableSearch, EUITagTarget.TableBodyCell];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Object];
    allowNullRule: boolean = false;

    parse(input: IUITagInput): IUITagResult | null {
        let rule: IUISearchParents = ObjectHelper.deepMerge(
            defaultData,
            this.parseRule(input),
        ) as unknown as IUISearchParents;
        if (rule == null) return null;

        const loopOverRule = (
            rule: IUISearchParents,
            hierachy: string[] = [],
            map: any = {},
        ): any => {
            const { quick, name, type } = rule;
            const parents = QuickHelper.getParents(quick);
            if (parents == null) return map;

            for (const parent of parents) {
                const childHierachy = [...hierachy, parent.propertyName];
                map[[...childHierachy, name].join(".")] = [type, true];
                loopOverRule({ ...rule, quick: parent.quick }, childHierachy, map);
            }

            return map;
        };

        const result = loopOverRule(rule);
        /// also include the child name / type
        result[String(rule.name ?? defaultData.name)] = [
            rule.type ?? defaultData.type,
            true,
        ];

        let moreTags: IUITagMoreTagsUnit[] = [
            {
                tag: "uiSearch",
                rule: result,
            },
        ];
        return {
            specials: {
                moreTags,
            },
        };
    }
}
